export const inr = (v: number | null | undefined) => `₹${Math.round(v || 0).toLocaleString('en-IN')}`;

export const lakh = (v: number | null | undefined) => {
  const n = v || 0;
  if (n >= 1e7) return `₹${(n / 1e7).toFixed(2)} Cr`;
  if (n >= 1e5) return `₹${(n / 1e5).toFixed(2)} L`;
  return inr(n);
};

export const num = (v: number | null | undefined) => (v || 0).toLocaleString('en-IN');

/** Percentage of part over whole, one decimal; an em dash when there is no whole. */
export const ratio = (part: number, whole: number): number | null =>
  whole > 0 ? Math.round((1000 * part) / whole) / 10 : null;

export const pct = (v: number | null | undefined) => (v === null || v === undefined ? '—' : `${v}%`);

/** "aereka RICHA" -> "Aereka Richa" */
export const titleCase = (n: string) =>
  (n || '').toLowerCase().replace(/(^|[\s.'-])([a-z])/g, (_, a, b) => a + b.toUpperCase());
